import { ReactNode, useState } from 'react';

const defaultReviews = [
  { name: 'Kevin M.', text: 'I ordered this as a gift and ended up wanting one for myself.' },
  { name: 'Sophie K.', text: 'I uploaded a selfie and a separate photo of my pet, and it came together beautifully.' },
  { name: 'Anna P.', text: 'The details are subtle but really well done.' },
  { name: 'Lena C.', text: 'It is more emotional than I expected. The image feels warm and familiar.' },
  { name: 'Megan T.', text: 'I ordered this to capture our bond, and it did exactly that.' },
  { name: 'Lucas M.', text: 'I bought this as a gift and she absolutely loved it.' }
];

export function Reviews({ config, variant = 'full' }: { config?: PortraitReviewsConfig; variant?: 'full' | 'summary' }) {
  const items = config?.items?.filter((item) => item.name && item.text).length
    ? config.items.filter((item) => item.name && item.text)
    : defaultReviews;
  const support = config?.support || { heading: 'Need Support?', content: "We're always here for you!" };
  const about = config?.about || {
    heading: 'About this store',
    content: 'We create meaningful custom portraits that celebrate the bond between people and their pets.'
  };
  const headingSuffix = config?.headingSuffix || 'Pet Parents';
  const linkLabel = config?.linkLabel || 'Read all reviews on Trustpilot';
  const linkUrl = config?.linkUrl || '';

  return (
    <section className={`reviews-section ${variant === 'summary' ? 'reviews-section-summary' : ''}`}>
      <h2>
        {config?.heading || 'Chosen by'} <em>{config?.headingEmphasis || '50,000+'}</em> {headingSuffix}
      </h2>
      <p className="rating">
        <span>★★★★★</span> <strong>{config?.ratingText || '4.6 out of 5'}</strong>
      </p>
      {linkLabel && (
        linkUrl ? (
          <a className="reviews-link" href={linkUrl} target="_blank" rel="noreferrer">
            {linkLabel}
          </a>
        ) : (
          <span className="reviews-link">{linkLabel}</span>
        )
      )}
      {variant === 'summary' ? null : (
      <div className="review-panel">
        <ReviewDetails
          heading={config?.panelHeading || 'What Customers Say'}
          open
          content={
            <div className="review-grid">
              {items.map(({ name, text }) => (
                <article className="review-card" key={name}>
                  <div className="stars">★★★★★</div>
                  <p>"{text}"</p>
                  <strong>- {name}</strong>
                </article>
              ))}
            </div>
          }
        />
        <div className="review-accordions">
          <ReviewDetails heading={support.heading} content={support.content} open={support.open} />
          <ReviewDetails heading={about.heading} content={about.content} open={about.open} />
        </div>
      </div>
      )}
    </section>
  );
}

function ReviewDetails({ heading, content, open }: Omit<PortraitAccordionConfig, 'content'> & { content: ReactNode }) {
  const [isOpen, setIsOpen] = useState(!!open);

  if (!heading && !content) return null;

  return (
    <div className={`review-details ${isOpen ? 'is-open' : ''}`}>
      <button
        type="button"
        className="review-details-trigger"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((current) => !current)}
      >
        <span>{heading}</span>
        <span className="review-details-icon" aria-hidden="true" />
      </button>
      <div className="review-details-content" aria-hidden={!isOpen}>
        <div>{typeof content === 'string' ? content && <p>{content}</p> : content}</div>
      </div>
    </div>
  );
}
